<template>
  <b-card class="bg-white rounded-xl">
    <div class="flex items-center">
      <div class="mr-2" @click="handleClick('service-partner')">
        <feather-icon
          icon="ChevronLeftIcon"
          svgClasses="w-7 h-7 font-bold text-black cursor-pointer"
          class=""
        ></feather-icon>
      </div>
      <h2 class="text-2xl font-semibold mt-4 mb-4">Edit Service Offerings</h2>
    </div>

    <validation-observer v-slot="{ handleSubmit }" ref="formValidator">
      <b-form role="form" @submit.prevent="handleSubmit(onSubmit)">
        <base-input
          alternative
          class="mb-3"
          name="Title"
          :rules="{ required: true }"
          placeholder="Title"
          v-model="service_data.title"
        >
        </base-input>
        <base-input
          alternative
          class="mb-3"
          name="Title"
          :rules="{ required: true }"
          placeholder="Title"
          v-model="service_data.categoryid.title"
          :readonly="service_data.categoryid.title"
        >
        </base-input>
        <!-- <div class="mb-4">
          <p class="input-title text-black opacity-50">Select Categories</p>
          <b-form-select v-model="service_data.categoryid.title">
            <b-form-select-option
              v-for="option in options"
              :value="option"
              :key="option._id"
              name="Relationship"
              :rules="{ required: true }"
              >{{ option.text }}
            </b-form-select-option></b-form-select
          >
        </div> -->
        <!-- <FileUploader
          v-show="!image"
          :image="image"
          :onSuccess="handleSuccess"
        />

        <div v-if="image">
          <p class="mb-2 text-danger">Image Preview</p>

          <div class="flex cursor-pointer items-center my-2" v-if="image">
            <base-button type="danger" class="px-8" @click="handleRemove">
              Remove image
            </base-button>
          </div>
          <img v-if="image" :src="image" ref="cover" />
        </div>

        <div class="mt-3 mb-4">
          <p class="mb-2">Uploaded Image</p>
          <img
            class="w-1/2"
            :src="$imageURL + '/' + service_data.image"
            alt="uploaded-image"
          />
        </div> -->
        <quill-editor
          v-model="service_data.description"
          :options="editorOption"
          class="quill-h200px my-2"
        />

        <base-button
          type="primary"
          outline
          class="w-full my-2"
          native-type="submit"
          >Save</base-button
        >
      </b-form>
    </validation-observer>
  </b-card>
</template>

<script>
import FileUploader from "@/components/FileUploader";

import { quillEditor } from "vue-quill-editor";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";

import { mapState } from "vuex";

export default {
  components: {
    FileUploader,
    quillEditor,
  },
  data() {
    return {
      title: "",
      discription: "",
      selected: [],
      image: "",
      coverImage: "",
      filter1: [],
      filter2: [],
      filter3: [],
      Ctags: [],
      editorOption: {
        theme: "snow",
      },
      pageData: {},
      service_data: {},
    };
  },
  computed: {
    ...mapState("services", {
      selectpartner: "selectpartner",
    }),
  },
  watch: {
    pageData(val) {
      this.service_data = { ...val };
      // console.log(this.service_data);
    },
  },
  methods: {
    handleSuccess(image) {
      this.coverImage = image;
      this.readerData(image);
    },

    readerData(rawFile) {
      let loader = this.$loading();

      const reader = new FileReader();
      reader.onload = (e) => {
        this.$emit("load", (this.image = e.target.result));

        loader.close();
      };
      reader.readAsDataURL(rawFile);
    },
    async onSubmit() {
      let FormData = require("form-data");
      let data = new FormData();
      data.append("_id", this.service_data._id);
      data.append("title", this.service_data.title);
      data.append("description", this.service_data.description);
      let loader = this.$loading();
      try {
        const editData = await this.$store.dispatch(
          "services/editpartner",
          data
        );
        // if (editData.code == 200) {
        this.$router.push({ name: "service-partner" });
        this.$swal.fire({
          text: "Service Offerings Edited Successfully",
          icon: "success",
          confirmButtonText: "Okay",
          confirmButtonColor: "#830c81",
          showCancelButton: false,
        });
        loader.close();
        // }
      } catch (error) {
        if (error) {
          loader.close();
        }
      }
    },
    async init() {
      this.pageData = this.selectpartner;
    },
    handleRemove() {
      this.image = null;
      this.coverImage = null;
    },
    handleClick(name) {
      this.$router.push({ name: name });
    },
  },
  mounted() {
    this.init();
    // console.log(this.selectpartner);
  },
};
</script>

<style>
.h300px {
  height: 300px !important;
}
.imgupload {
  height: 270px !important;
}
</style>
